import ExchangeModal from "./ExchangeModal";

export default function KeyExchangeModal({
  open,
  keyItem,
  gems,
  gemCounts,
  onClose,
  onSuccess,
}) {
  return (
    <ExchangeModal
      open={open}
      item={keyItem}
      itemKind="key"
      gems={gems}
      gemCounts={gemCounts}
      onClose={onClose}
      onSuccess={onSuccess}
    />
  );
}
